/**
 * Typography scale — generated from DTCG tokens.
 *
 * Source of truth: internal/tokens/theme/generated/typography.json
 * To update: modify Figma tokens → run `nx run tokens:sync-build`
 *
 * @see {@link @mds/tokens}
 */

import { typography as typographyTokens } from '@mds/tokens';
import type { TypographyVariantsOptions } from '@mui/material/styles';

/**
 * See packages/ui/src/theme/types.ts for custom typography variant typedefs
 */
export const typography: TypographyVariantsOptions = {
  fontFamily: typographyTokens.fontFamily,
  fontSize: typographyTokens.fontSize,
  fontWeightLight: typographyTokens.fontWeightLight,
  fontWeightRegular: typographyTokens.fontWeightRegular,
  fontWeightMedium: typographyTokens.fontWeightMedium,
  fontWeightBold: typographyTokens.fontWeightBold,
  h1: {
    fontFamily: typographyTokens.h1.fontFamily,
    fontWeight: typographyTokens.h1.fontWeight,
    fontSize: typographyTokens.h1.fontSize,
    lineHeight: typographyTokens.h1.lineHeight,
    letterSpacing: typographyTokens.h1.letterSpacing,
  },
  h2: {
    fontFamily: typographyTokens.h2.fontFamily,
    fontWeight: typographyTokens.h2.fontWeight,
    fontSize: typographyTokens.h2.fontSize,
    lineHeight: typographyTokens.h2.lineHeight,
    letterSpacing: typographyTokens.h2.letterSpacing,
  },
  h3: {
    fontFamily: typographyTokens.h3.fontFamily,
    fontWeight: typographyTokens.h3.fontWeight,
    fontSize: typographyTokens.h3.fontSize,
    lineHeight: typographyTokens.h3.lineHeight,
    letterSpacing: typographyTokens.h3.letterSpacing,
  },
  h4: {
    fontFamily: typographyTokens.h4.fontFamily,
    fontWeight: typographyTokens.h4.fontWeight,
    fontSize: typographyTokens.h4.fontSize,
    lineHeight: typographyTokens.h4.lineHeight,
    letterSpacing: typographyTokens.h4.letterSpacing,
  },
  h5: {
    fontFamily: typographyTokens.h5.fontFamily,
    fontWeight: typographyTokens.h5.fontWeight,
    fontSize: typographyTokens.h5.fontSize,
    lineHeight: typographyTokens.h5.lineHeight,
    letterSpacing: typographyTokens.h5.letterSpacing,
  },
  h6: {
    fontFamily: typographyTokens.h6.fontFamily,
    fontWeight: typographyTokens.h6.fontWeight,
    fontSize: typographyTokens.h6.fontSize,
    lineHeight: typographyTokens.h6.lineHeight,
    letterSpacing: typographyTokens.h6.letterSpacing,
  },
  subtitle1: {
    fontFamily: typographyTokens.subtitle1.fontFamily,
    fontWeight: typographyTokens.subtitle1.fontWeight,
    fontSize: typographyTokens.subtitle1.fontSize,
    lineHeight: typographyTokens.subtitle1.lineHeight,
    letterSpacing: typographyTokens.subtitle1.letterSpacing,
  },
  subtitle2: {
    fontFamily: typographyTokens.subtitle2.fontFamily,
    fontWeight: typographyTokens.subtitle2.fontWeight,
    fontSize: typographyTokens.subtitle2.fontSize,
    lineHeight: typographyTokens.subtitle2.lineHeight,
    letterSpacing: typographyTokens.subtitle2.letterSpacing,
  },
  body1: {
    fontFamily: typographyTokens.body1.fontFamily,
    fontWeight: typographyTokens.body1.fontWeight,
    fontSize: typographyTokens.body1.fontSize,
    lineHeight: typographyTokens.body1.lineHeight,
    letterSpacing: typographyTokens.body1.letterSpacing,
  },
  body2: {
    fontFamily: typographyTokens.body2.fontFamily,
    fontWeight: typographyTokens.body2.fontWeight,
    fontSize: typographyTokens.body2.fontSize,
    lineHeight: typographyTokens.body2.lineHeight,
    letterSpacing: typographyTokens.body2.letterSpacing,
  },
  label1: {
    fontFamily: typographyTokens.label1.fontFamily,
    fontWeight: typographyTokens.label1.fontWeight,
    fontSize: typographyTokens.label1.fontSize,
    lineHeight: typographyTokens.label1.lineHeight,
    letterSpacing: typographyTokens.label1.letterSpacing,
  },
  label2: {
    fontFamily: typographyTokens.label2.fontFamily,
    fontWeight: typographyTokens.label2.fontWeight,
    fontSize: typographyTokens.label2.fontSize,
    lineHeight: typographyTokens.label2.lineHeight,
    letterSpacing: typographyTokens.label2.letterSpacing,
  },
  label3: {
    fontFamily: typographyTokens.label3.fontFamily,
    fontWeight: typographyTokens.label3.fontWeight,
    fontSize: typographyTokens.label3.fontSize,
    lineHeight: typographyTokens.label3.lineHeight,
    letterSpacing: typographyTokens.label3.letterSpacing,
  },
  label4: {
    fontFamily: typographyTokens.label4.fontFamily,
    fontWeight: typographyTokens.label4.fontWeight,
    fontSize: typographyTokens.label4.fontSize,
    lineHeight: typographyTokens.label4.lineHeight,
    letterSpacing: typographyTokens.label4.letterSpacing,
  },
  button: {
    fontFamily: typographyTokens.button.fontFamily,
    fontWeight: typographyTokens.button.fontWeight,
    fontSize: typographyTokens.button.fontSize,
    lineHeight: typographyTokens.button.lineHeight,
    letterSpacing: typographyTokens.button.letterSpacing,
    textTransform: typographyTokens.button.textTransform,
  },
  caption: {
    fontFamily: typographyTokens.caption.fontFamily,
    fontWeight: typographyTokens.caption.fontWeight,
    fontSize: typographyTokens.caption.fontSize,
    lineHeight: typographyTokens.caption.lineHeight,
    letterSpacing: typographyTokens.caption.letterSpacing,
  },
  overline1: {
    fontFamily: typographyTokens.overline1.fontFamily,
    fontWeight: typographyTokens.overline1.fontWeight,
    fontSize: typographyTokens.overline1.fontSize,
    lineHeight: typographyTokens.overline1.lineHeight,
    letterSpacing: typographyTokens.overline1.letterSpacing,
    textTransform: typographyTokens.overline1.textTransform,
  },
  overline2: {
    fontFamily: typographyTokens.overline2.fontFamily,
    fontWeight: typographyTokens.overline2.fontWeight,
    fontSize: typographyTokens.overline2.fontSize,
    lineHeight: typographyTokens.overline2.lineHeight,
    letterSpacing: typographyTokens.overline2.letterSpacing,
    textTransform: typographyTokens.overline2.textTransform,
  },
  overline: {
    fontFamily: typographyTokens.overline.fontFamily,
    fontWeight: typographyTokens.overline.fontWeight,
    fontSize: typographyTokens.overline.fontSize,
    lineHeight: typographyTokens.overline.lineHeight,
    letterSpacing: typographyTokens.overline.letterSpacing,
  },
};
